import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: "deleteModuleType",
    serviceName: "admin",
    query: gql`
      mutation deleteModuleType($ids: [String]!) {
        deleteModuleType(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
